// 96-bin RMS envelopes generated from the shipped comparison MP3 files.
export const SKINSCRAPER_FULL_MIX_WAVEFORM = [
  0.077, 0.154, 0.172, 0.173, 0.166, 0.18, 0.183, 0.191, 0.18, 0.19, 0.203, 0.189,
  0.214, 0.207, 0.187, 0.682, 0.784, 0.431, 0.444, 0.611, 0.839, 0.737, 0.96, 0.721,
  0.735, 0.855, 0.727, 0.822, 0.87, 0.852, 0.895, 0.817, 0.845, 0.782, 0.889, 0.91,
  0.819, 0.826, 0.85, 0.888, 0.915, 0.851, 0.893, 0.848, 0.838, 0.832, 0.875, 0.868,
  0.803, 0.819, 0.723, 0.874, 0.903, 0.905, 0.89, 1, 0.819, 0.86, 0.871, 0.931,
  0.779, 0.799, 0.919, 0.841, 0.903, 0.87, 0.833, 0.813, 0.857, 0.866, 0.82, 0.822,
  0.857, 0.879, 0.81, 0.887, 0.894, 0.716, 0.776, 0.835, 0.945, 0.867, 0.894, 0.946,
  0.797, 0.824, 0.893, 0.818, 0.798, 0.763, 0.711, 0.52, 0.403, 0.254, 0.093, 0.06,
];

export const SKINSCRAPER_BASS_ONLY_WAVEFORM = [
  0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06,
  0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.62, 1, 0.799, 0.922, 0.852,
  0.931, 0.862, 0.821, 0.782, 0.765, 0.8, 0.888, 0.89, 0.858, 0.898, 0.913, 0.882,
  0.935, 0.89, 0.867, 0.827, 0.811, 0.808, 0.907, 0.922, 0.938, 0.924, 0.811, 0.796,
  0.83, 0.818, 0.813, 0.92, 0.926, 0.923, 0.926, 0.942, 0.918, 0.951, 0.982, 0.939,
  0.921, 0.887, 0.921, 0.843, 0.788, 0.765, 0.854, 0.851, 0.798, 0.818, 0.718, 0.693,
  0.713, 0.841, 0.853, 0.838, 0.886, 0.899, 0.873, 0.892, 0.938, 0.854, 0.911, 0.899,
  0.931, 0.886, 0.912, 0.895, 0.846, 0.789, 0.829, 0.683, 0.516, 0.273, 0.104, 0.06,
];

export const FLESHWEAVER_FULL_MIX_WAVEFORM = [
  0.073, 0.149, 0.171, 0.172, 0.165, 0.182, 0.181, 0.188, 0.184, 0.188, 0.202, 0.191,
  0.209, 0.208, 0.185, 0.752, 0.709, 0.435, 0.441, 0.629, 0.792, 0.727, 0.956, 0.673,
  0.788, 0.878, 0.817, 0.815, 0.863, 0.879, 0.862, 0.944, 0.948, 0.845, 0.864, 0.871,
  0.833, 0.86, 0.793, 0.805, 0.933, 0.899, 0.842, 0.86, 0.938, 0.834, 0.827, 0.898,
  0.903, 0.835, 0.843, 0.834, 0.828, 1, 0.987, 0.91, 0.92, 0.857, 0.902, 0.89,
  0.905, 0.861, 0.961, 0.891, 0.886, 0.843, 0.959, 0.75, 0.911, 0.915, 0.795, 0.866,
  0.873, 0.917, 0.94, 0.839, 0.831, 0.844, 0.813, 0.871, 0.858, 0.995, 0.904, 0.874,
  0.819, 0.877, 0.884, 0.946, 0.777, 0.775, 0.607, 0.441, 0.32, 0.149, 0.06, 0.06,
];

export const FLESHWEAVER_BASS_ONLY_WAVEFORM = [
  0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06,
  0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.06, 0.661, 0.824, 0.646, 0.721, 0.651,
  0.841, 0.872, 0.884, 0.869, 0.791, 0.87, 0.871, 0.928, 0.909, 0.916, 0.922, 0.896,
  0.892, 0.887, 0.908, 0.93, 0.946, 0.919, 0.921, 0.993, 0.993, 0.954, 0.776, 0.868,
  0.904, 0.808, 0.92, 0.893, 0.926, 0.961, 0.973, 0.917, 0.984, 0.972, 0.958, 0.94,
  0.946, 0.919, 0.867, 0.833, 0.767, 0.781, 0.92, 0.759, 0.919, 0.794, 0.75, 0.754,
  0.826, 0.895, 0.921, 0.89, 0.925, 0.893, 0.893, 0.942, 0.913, 0.96, 1, 0.916,
  0.928, 0.902, 0.966, 0.93, 0.868, 0.775, 0.717, 0.575, 0.356, 0.16, 0.06, 0.06,
];

export const BASS_SIM_ON_WAVEFORM = [
  0.06, 0.57, 0.85, 0.893, 0.808, 0.612, 0.879, 0.838, 0.643, 0.844, 0.714, 0.633,
  0.669, 0.696, 0.702, 0.814, 0.739, 0.627, 0.792, 0.617, 0.753, 0.795, 0.654, 0.713,
  0.682, 0.721, 0.742, 0.747, 0.593, 0.837, 0.846, 0.658, 0.827, 0.847, 0.74, 0.962,
  0.824, 0.621, 0.679, 0.736, 0.606, 0.707, 0.774, 0.615, 0.769, 0.744, 0.717, 0.552,
  0.719, 0.683, 0.618, 0.64, 0.772, 0.902, 0.766, 0.728, 0.856, 0.755, 0.785, 0.969,
  0.816, 0.81, 0.772, 0.657, 0.756, 0.893, 0.743, 0.657, 0.647, 0.714, 0.738, 0.7,
  0.818, 0.623, 0.855, 0.803, 0.688, 0.892, 0.907, 0.603, 0.863, 0.707, 0.808, 1,
  0.861, 0.536, 0.635, 0.704, 0.785, 0.913, 0.783, 0.633, 0.816, 0.897, 0.923, 0.727,
];

export const BASS_SIM_OFF_WAVEFORM = [
  0.06, 0.803, 0.718, 0.505, 0.654, 0.664, 0.414, 0.558, 0.51, 0.391, 0.659, 0.438,
  0.289, 0.645, 0.574, 0.374, 0.828, 0.584, 0.422, 0.739, 0.732, 0.733, 0.91, 0.611,
  0.45, 1, 0.541, 0.587, 0.859, 0.549, 0.714, 0.597, 0.403, 0.736, 0.75, 0.474,
  0.706, 0.482, 0.359, 0.812, 0.614, 0.373, 0.903, 0.531, 0.691, 0.547, 0.542, 0.427,
  0.801, 0.64, 0.489, 0.808, 0.756, 0.568, 0.723, 0.555, 0.529, 0.8, 0.75, 0.532,
  0.633, 0.445, 0.321, 0.86, 0.625, 0.524, 0.788, 0.647, 0.834, 0.854, 0.74, 0.663,
  0.734, 0.692, 0.483, 0.778, 0.761, 0.538, 0.672, 0.583, 0.46, 0.729, 0.646, 0.446,
  0.692, 0.473, 0.331, 0.829, 0.669, 0.535, 0.718, 0.509, 0.385, 0.885, 0.72, 0.422,
];
